var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('dashboard-layout',{attrs:{"dashboards":_vm.dashboards,"updateDashboardData":_vm.updateDashboardData,"filters":_vm.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }